import { Icon } from "native-base";
import React from "react";
import { ClipPath, Defs, G, Path, Svg } from "react-native-svg";

import { IIconProps } from "../../interfaces/IIconprops";

export function RoundCrossIcon({ ...props }: IIconProps) {
  return (
    <Icon viewBox="0 0 68 68" {...props}>
      <Svg width={68} height={68} fill="none">
        <G
          clipPath="url(#a)"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <Path
            d="M48.166 48.167c7.824-7.824 7.824-20.51 0-28.334-7.824-7.824-20.51-7.824-28.333 0-7.824 7.824-7.824 20.51 0 28.334 7.824 7.824 20.509 7.824 28.333 0Z"
            fill="#C4C4C4"
            stroke="#C4C4C4"
          />
          <Path
            d="m28.334 28.333 11.333 11.334M28.334 39.667l11.333-11.334"
            stroke="#fff"
          />
        </G>
        <Defs>
          <ClipPath id="a">
            <Path
              fill="#fff"
              transform="rotate(-45 41.042 17)"
              d="M0 0h48.083v48.083H0z"
            />
          </ClipPath>
        </Defs>
      </Svg>
    </Icon>
  );
}
